import { PhotoCollageTool } from '@/features/photo-collage'

export function PhotoCollagePage() {
  return <PhotoCollageTool />
}
